import { useState } from "react";
import { Col } from "react-bootstrap";
import { createUseStyles } from "react-jss";
import { useParams } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import { FormValuesType, QuestionsRawType, QuestionType } from "types";

type OpenAnswerType = {
  section: QuestionsRawType;
  formValues: FormValuesType[];
  setFormValues: (value: React.SetStateAction<FormValuesType[]>) => void;
  question: QuestionType;
  questions: {
    id: string;
    text: string;
    answers: number[];
  }[];
};

export const OpenAnswer: React.FC<OpenAnswerType> = ({
  section,
  setFormValues,
  question,
}) => {
  const classes = useStyles();
  const { uuid } = useParams();

  const [openAnswerValue, setOpenAnswerValue] = useState(() => {
    const localStorageSurveyData = JSON.parse(
      localStorage.getItem(`DilsSurvey-${uuid}`) ?? "{}"
    );

    return (localStorageSurveyData.formValues as FormValuesType[]).find(
      (item) => item.questionId === question.id
    )?.openAnswer;
  });

  const handleOpenAnswerChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setFormValues((prevFormValues) => {
      const existingAnswerIndex = prevFormValues.findIndex(
        (item) => item.questionId === question.id
      );

      const updatedFormValues = [...prevFormValues];

      const oldAnswer = updatedFormValues[existingAnswerIndex];

      updatedFormValues[existingAnswerIndex] = {
        sectionCode: section.sectionCode,
        questionId: question.id,
        question: oldAnswer.question,
        openAnswer: e.target.value,
        answer: oldAnswer.answer,
        range: oldAnswer.range,
        measurable: oldAnswer.measurable,
        answersMeaning: oldAnswer.answersMeaning,
      };
      return updatedFormValues;
    });

    setOpenAnswerValue(e.target.value);
  };

  return (
    <Fragment>
      <Col xs={12}>
        <textarea
          rows={3}
          className={`${classes.textArea} mt-3`}
          placeholder={question.textAreaLabel ?? "Come possiamo migliorare?"}
          onChange={(e) => handleOpenAnswerChange(e)}
          value={openAnswerValue}
        />
      </Col>
    </Fragment>
  );
};

const useStyles = createUseStyles({
  textArea: {
    width: "100%",
    borderRadius: 5,
    border: "1px solid #D2D7ED",
    backgroundColor: "#F6F7FB",
    padding: 15,
    "&:focus-visible, &:focus, &:active": {
      outlineColor: "#CCC",
    },
  },
});
